import React, {Component} from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {BeatLoader} from "react-spinners";
import {connect}  from  "react-redux";
import {Redirect} from "react-router";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config,user_activities } from '../../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function getMonth(date) {
    var month = date.getMonth() + 1;
   // console.log("ooo",month);
    return month < 10 ? '0' + month : '' + month;
}

var prevMonthName  = moment().subtract(1, "month").format('MMMM');
var monthDefaults  = moment().subtract(1, "month").format('MM');
var yearDefault  = moment().subtract(1, "month").format('YYYY');


let month_years = "" +monthDefaults+yearDefault;
// alert(month_years)
const months = new Array("01", "02", "03", "04", "05", "06",
    "07", "08", "09", "10", "11", "12"
);
var timestamp = new Date().getTime();
var monthOptions = [];
var monthName = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
var d = new Date();

d.setDate(1);

var curr_yr = d.getFullYear();
var prevMonth = monthName[d.getMonth()-1]
for (var i=0; i<=11; i++) {
        monthOptions.push({ value: months[d.getMonth()]+d.getFullYear(), label: monthName[d.getMonth()] + ' ' +d.getFullYear() })
}
monthOptions.shift();

const monthConfig = {
  "01": 'January',
  "02": 'February',
  "03": 'March',
  "04": 'April',
  "05": 'May',
  "06": 'June',
  "07": 'July',
  "08": 'August',
  "09": 'September',
  "10": 'October',
  "11": 'November',
  "12": 'December',
}

class BinManagerSummaryReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            isChange: false,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            binList:[],
            bin_no:'',
            binValue:null,
            binStatusList:[],
            bin_status:'',
            binStatusValue:null,
            ciTenderModeList:[],
            ci_tender_mode:'',
            ciTenderModeValue:null,
            monthValue:null,
            m_yr:"",
            monthID: "",
            monthsLists:monthOptions,
            currMyN:"",
            currMyN:"",
            show_export_btn:false,
            bin_issue_summary:[],
            table_loading:true
        }
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, "ubc_txn_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }
        if(decoded.object_type==='Acquiring Bank'){
            this.setState({
                acqBankIds: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        }
    componentDidUpdate() {
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this.bin_txn_month_filters();
        //this._getBin_status();
        this._getci_tender_mode();



        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
//             this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
//             this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');
            this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: decoded.object_code,
                search_type:'innoviti',
                search_object_code: decoded.object_code,
            })
        }
        else if(decoded.object_type=='Merchant') {
//             this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
//             this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            setTimeout(function(){
                this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            //this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            setTimeout(function(){
                this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
            setTimeout(function(){
                this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }

        else {
            this.unauthorize_access();
        }
    user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'txn_failure_bin_issues_summary_report','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(reportPermissions.includes("binmanager_summary_report")===false){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    get_filtered_bin_manager_report(object_type, object_code, event) {

        var that = this;
        $('.dataTables_processing', $('#binManagerTable').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
        axios.post(config.get('API_URL') + '/summaryReport/bin_manager_summary_report/', {
             bin_no: that.state.bin_no,
             bin_status:that.state.bin_status,
             ci_tender_mode:that.state.ci_tender_mode,
             months: that.state.m_yr,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {


            if ($.fn.DataTable.isDataTable('#binManagerTable')) {
                $('#binManagerTable').DataTable().destroy();
            }
            that.setState({
                bin_issue_summary: response.data.data,
                table_loading:false,
                show_export_btn:true
            })
            let total = '';
            let pageTotal = '';
            let binManagerTable = $('#binManagerTable').DataTable({
//                 searching: false,
                bInfo : false,
//                 paging: false,
                "aaSorting": [],
                bProcessing: true,
            });
            $('.dataTables_processing', $('#binManagerTable').closest('.dataTables_wrapper')).hide();
            if(that.state.ci_tender_mode.includes("EMI")===true || that.state.ci_tender_mode=="") {
              binManagerTable.columns(1).visible(true);
            } else {
                binManagerTable.columns(1).visible(false);
            }

            if(that.state.ci_tender_mode.includes("EFT")===true || that.state.ci_tender_mode=="") {
                binManagerTable.columns(2).visible(true);
            } else {
                binManagerTable.columns(2).visible(false);
            }
        }, 100);
        });

    }

    bin_txn_month_filters(){

        axios.get(config.get('API_URL')+'/filters/bin_txn_month_filters/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var moList = []

                response.data.map((month, index) => {

                    let month_year = month.month;
                    let mo = month_year.substring(0, 2);
                    let year = month_year.substring(2, 6);
                    let month_name = monthConfig[mo]+" "+year;

                    moList.push({value: month.month, label: month_name})
                });
                this.setState({
                    monthsLists:moList,
                })
                //console.log(moList)
            }

        });
    }

    _getBin_status(){
        axios.get(config.get('API_URL')+'/filters/bin_status_filter/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((bin, index) => {
                    mList.push({value: bin.bin_status, label: bin.bin_status})
                });
                this.setState({
                    binStatusList:mList,

                })
            }
        });
    }
    _getci_tender_mode(){
        axios.get(config.get('API_URL')+'/filters/ci_tender_mode_filter/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((bin, index) => {
                    mList.push({value: bin.ci_tender_mode, label: bin.ci_tender_mode})
                });
                this.setState({
                    ciTenderModeList:mList,

                })
            }
        });
    }

    changeBinNo(optionSelected){
        let value='';
        let binArray = [];
        if(optionSelected.length<1){
            value = null;
            binArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                binArray.push(mids.value)

            });
        }

        this.setState({
            bin_no:binArray,
            binValue:optionSelected,
            isChange: true,

        });


    }
    changeBinStatus(optionSelected){
        let value='';
        let binsArray = [];
        if(optionSelected.length<1){
            value = null;
            binsArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                binsArray.push(mids.value)

            });
        }

        this.setState({
            bin_status:binsArray,
            binStatusValue:optionSelected,
            isChange: true,

        });


    }
    changeCiTenderMode(optionSelected){
        let value='';
        let ciTenderArray = [];
        if(optionSelected.length<1){
            value = null;
            ciTenderArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                ciTenderArray.push(mids.value)

            });
        }

        this.setState({
            ci_tender_mode:ciTenderArray,
            ciTenderModeValue:optionSelected,
            isChange: true,

        });


    }
    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            var is_date_change = false;
            if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                is_date_change = false;
            } else {
                is_date_change = true;
            }
            this.setState({
                isChange: is_date_change
            })
            //this.get_filtered_bin_manager_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.yestSend, this.state.todSend)
        }
    }
BinManagerDownloadCheck(){

      this.BinManagerDownload()

    }
    BinManagerDownload (e){
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if (days_beet > 30) {
            alert("Date range too large. Please select a date range of 30 days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
//             bin_no: this.state.bin_no,
//             bin_status:this.state.bin_status,
            ci_tender_mode:this.state.ci_tender_mode,
            months: this.state.m_yr,
            download: true

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/summaryReport/bin_manager_summary_report_download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyAcqFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyAcqFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'bin_manager_summary_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }

    DistinctBinManagerDownloadCheck(){

      this.DistinctBinManagerDownload()

    }
    DistinctBinManagerDownload (e){
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            bin_no: this.state.bin_no,
            bin_status:this.state.bin_status,
            ci_tender_mode:this.state.ci_tender_mode,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            download: true

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/schedulereport/distinct_bin-manager-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyAcqFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyAcqFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'bin_manager_summary_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            ci_tender_mode:'',
            ciTenderModeValue:[],
            monthValue:[],
            m_yr:"",

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    changeMonth(optionSelected) {
        let value='';
        let mArray = [];
        if(optionSelected.length<1){
            value = null;
            mArray = '';
        }
        else{
            optionSelected.map((months, i) => {
                mArray.push(months.value)

                var index = this.state.monthsLists.findIndex(obj => obj.value == months.value);
                this.state.monthsLists.move(index, 0).join(',');

            });

        }
        this.setState({
            m_yr: mArray,
            monthValue:optionSelected,
            isChange: true,
        });
    }

    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };

        const bin_issue_summary = this.state.bin_issue_summary.map((data, index) => {
            const month_y = data['Month/YEAR'];
            const myArray = month_y.split("-");
            let res_year = myArray[0];
            let res_month= myArray[1];
            let month_txt = monthConfig[res_month]+" "+res_year;;


            return (
                <tr key={index}>
                    <td><span style={{display:'none'}}>{data['Month/YEAR']}</span> {month_txt}</td>
                    <td>{data['EMI']}</td>
                    <td>{data['EFT']}</td>
                    <td>{data['Total Count(EMI/EFT)']}</td>
                </tr>
            )
        });
        return(
           
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Transaction failure - BIN Issues - Summary Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Month: </label></div>

                                                <ReactMultiSelectCheckboxes name="month"
                                                    isMulti
                                                    value={this.state.monthValue}
                                                    styles={customStyles} className="chainLists"
                                                    isClearable={false}
                                                    onChange={this.changeMonth.bind(this)}
                                                    options={this.state.monthsLists}

                                                    placeholderButtonLabel="Select[Months]"
                                                />
                                        </div>


                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Tender Mode</label>
                                                <ReactMultiSelectCheckboxes name="bin_no"
                                                    isMulti
                                                    value={this.state.ciTenderModeValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    options={this.state.ciTenderModeList}
                                                    onChange={this.changeCiTenderMode.bind(this)}
                                                    placeholderButtonLabel="Select [Tender Mode]"
                                                />

                                                <div className="clearfix"></div>
                                            </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_bin_manager_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp;&nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.show_export_btn===true?
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.BinManagerDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>:null}

                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="binManagerTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                <th>Month/YEAR</th>
                                                <th >EMI</th>
                                                <th>EFT</th>
                                                <th>Total Count(EMI/EFT)</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bin_issue_summary}
                                            </tbody>
                                        </table>
                                        <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.table_loading}
                                    />
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
        );
    }
}
const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(BinManagerSummaryReport)